import config from '../config';

export function RequerimientoModalAnular({ onClose, dataLogin, requerimiento, closeSecondModal, obtenerRequerimientos, navigate }) {

  const handleSubmitAnularRequerimiento = async (event, idRequerimiento) => {
    event.preventDefault();

    try {
      const formAnularRequerimiento = {
        id_requerimiento: idRequerimiento,
        id_usuario_actualizacion: dataLogin.id_usuario
      };

      const responseAnularRequerimiento = await fetch(
        `${config.apiBaseUrl}/requerimiento.php?anula=1`,
        {
          method: "PUT",
          headers: {
            'Accept': 'application/json', // Indica que esperas una respuesta JSON
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formAnularRequerimiento),
        }
      );

      const dataAnularRequerimiento = await responseAnularRequerimiento.json();
      if (dataAnularRequerimiento.message === "Requerimiento anulado con éxito.") {
        alert("Requerimiento anulado con éxito.");
        closeSecondModal();
        onClose();
        obtenerRequerimientos();
        navigate("/dashboard", { state: dataLogin });
      }
    } catch (error) {
      alert("Error al anular el requerimiento");
    }
  }
  return (
    <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
      <div className="modal-content">
        <div className="modal-header">
          <h4 className="mb-0">Anular Requerimiento</h4>
          <button onClick={onClose} className="btn-close"></button>
        </div>
        <div className="modal-body">
          <p className="fs-5">¿Está seguro que desea anular el requerimiento: <span className="text-red">{requerimiento.nombre_requerimiento}</span>?</p>
        </div>
        <div className="modal-footer">
          <button className="btn btn-danger" onClick={(e) => handleSubmitAnularRequerimiento(e, requerimiento.id_requerimiento)}><i className="bi bi-dash-circle"></i> Anular</button>
        </div>
      </div>
    </div>
  );
}